// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2RNls","title":"ClientCherryInfo_title__1aZR7","itemText":"ClientCherryInfo_itemText__13RlR"};